The identifier for the `Position` that failed to post or update.
